import { get, post, put } from 'helpers/api';

const rootPath = '/projects';

export function searchProjects(searchTerm, onSuccess) {
  const query = 'q[title_or_address_cont]';
  get(`${rootPath}/search.json`, { params: { [query]: searchTerm } })
    .then(function (response) {
      onSuccess(response.projects);
    });
}

export function bulkCreateLeads(projectId, leadData) {
  return post(`${rootPath}/${projectId}/leads/bulk_create`, { lead: leadData });
}

export function fetchShareableTokens(projectId) {
  return get(`${rootPath}/${projectId}/shareable_tokens`);
}

export function bulkUpdateShareableTokens(projectId, updates) {
  const params = { client_report_shareable_token_attributes: updates };
  return put(`${rootPath}/${projectId}/shareable_tokens/bulk_update`, params);
}
